export default {
   "space": process.env.SPACE,
   "accessToken": process.env.TOKEN,
   "host": process.env.CONTENTFUL_HOST
}
